import { render, staticRenderFns } from "./password-update.vue?vue&type=template&id=93b1053e&scoped=true&"
import script from "./password-update.vue?vue&type=script&lang=js&"
export * from "./password-update.vue?vue&type=script&lang=js&"
import style0 from "./password-update.vue?vue&type=style&index=0&id=93b1053e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b1053e",
  null
  
)

export default component.exports